import { createUUID } from '@/core/operation';

//瀑布流不同宽度布局个数
export const BREAK_POINTS = {
  1900: {
    rowPerView: 7,
  },
  1648: {
    rowPerView: 6,
  },
  1416: {
    rowPerView: 5,
  },
  1184: {
    rowPerView: 4,
  },
  952: {
    rowPerView: 3,
  },
  720: {
    //当屏幕宽度小于等于720
    rowPerView: 2,
  },
}

//卡片类型
export const CARD_TYPE = {
  //草稿类型
  DRAFT: 1,
  //形象
  IMAGE: 2,
  //声音
  SOUND: 3,
  //作品
  CREATION: 4,
  //数字人库
  DH: 5,
}

//我的创作tab
export const MY_CREATION_TAB ={
  //作品
  CREATION: 0,
  //草稿
  DRAFT: 1,
  //形象
  IMAGE: 2,
  //声音
  SOUND: 3,
}

//作品状态(形象、声音)
export const CREATION_STATUS = {
  //完成
  COMPLETE: 4,
  //正在合成(正在克隆)
  PROGRESS: 2,
  //排队中
  PEDDING: 1,
  //合成失败(克隆失败)
  ERROR: 6,
}

//到期状态
export const EXPIRE_TIME_STATUS = {
  //已到期
  EXPIRED: 2,
  //快到期
  PREEXPIRE: 1,
  //没到期
  UNEXPIRE: 0,
}

//性别类型
export const GENDER_TYPE = {
  //男性
  MALE: 1,
  //女性
  FEMALE: 2,
}

// 编辑类型
export const EDITOR_TYPE = {
  TEMPLATE: 1,      // 模板
  DIGITALHUMAN: 2,  // 数字人
  MATEERIAL: 3,     // 素材
  TEXT: 4,          // 文字
  BACKGROUND: 5,    // 背景
  IDENTIFY: 6,      // 企业标识
  MINE: 7,          // 我的
  TRANSLATE: 8,     // 翻译
  DIGITALHUMANBG: 9,// 形象底纹
}

// 编辑类型使用字符串
export const EDITOR_STRING_TYPE = {
  TEMPLATE: 'tmplate',        // 模板
  DIGITALHUMAN: 'dh',         // 数字人
  DIGITALHUMANBG: 'dhBg',     // 形象底纹
  MATERIAL: 'material',       // 素材
  TEXT: 'text',               // 文字
  BACKGROUND: 'bg',           // 背景
  IDENTIFY: 'logo',       // 企业标识
  MINE: 'mine',               // 我的
  TRANSLATE: 'translate',     // 翻译
  MAINSUBTITLE: 'mainsubtitle',// 主字幕
  SUBTITLE: 'subtitle',       // 次字幕
  CROPBOX: 'cropBox',         // 裁剪框
  TEMP: 'temp',         // 操作过程产生的临时元素
}

// 编辑封面图类型
export const EDITOR_COVER_TYPE = {
  VIDEO: 1,       // 视频
  IMG: 2,         // 图片
  SVG: 3,         // svg
  GIF: 4,         // gif
}

//旁白声音参数
export const SOUND_CONTROLS_TYPE = {
  //语速
  SPEED: 1,
  //音量
  VOLUME: 2,
  //语调
  PITCH: 3,
}

//画布形状类型
export const CANVAS_SHAPE = {
  //竖向
  VERTICAL: 1,
  //横向
  HORIZONTAL: 2,
  //其他
  OTHER: 3,
}

//新建草稿初始信息
export const DRAFT_DATA = {
  WIDTH: 1080,
  HEIGHT: 1920,
  SOUND_ID: 257,
  IMAGE_ID: 724,
  SPEED: 1,
  VOLUME: 100,
  PITCH: 0,
  HORIZONTAL_PARAMETER: {
    version: "5.3.0",
    objects: [{
        type: 'rect',
        left: 0,
        top: 0,
        width: 1920,
        height: 1080,
        fill: '#FFFFFF',
        id: EDITOR_STRING_TYPE.BACKGROUND,
        uuid: createUUID(),
    }]
  },
  VERTICAL_PARAMETER: {
    version: "5.3.0",
    objects: [{
        type: 'rect',
        left: 0,
        top: 0,
        width: 1080,
        height: 1920,
        fill: '#FFFFFF',
        id: EDITOR_STRING_TYPE.BACKGROUND,
        uuid: createUUID(),
    }]
  }
}

//编辑模式
export const EDIT_MODE = {
  CLOSE: 0,              //关闭
  SUBTITLE: 1,           //字幕
  LAYER: 2,              //图层
  TEXT: 3,               //字体 
  IMAGE: 4,              //图片/视频
  TEXT_COLOR: 5,         //字体颜色
  IMAGE_COLOR: 6,         //图片颜色
  DIGITALHUMAN: 7,         //数字人
  DIGITALHUMANBGSHAPE: 8,   //数字人背景形状
  IMAGESHAPE: 9,          // 数字人形象底纹  
  BACKGROUNDCOLOR: 10, //背景顔色         
}

//数字人背景形状
export const DHBG_SHAPE = {
  //矩形
  RECT: {
    id: 1,
    type: 'rect',
    width: 64,
    height: 64,
    rx: 0,
    url: require('@/assets/images/edit/dhBgShape/rect.svg'),
  },
  //圆角矩形
  ROUNDED_RECT: {
    id: 2,
    type: 'rect',
    width: 64,
    height: 64,
    rx: 7.11111,
    url: require('@/assets/images/edit/dhBgShape/rounded_rect.svg'),
  },
  //圆形
  CIRCLE: {
    id: 3,
    type: 'rect',
    width: 64,
    height: 64,
    rx: 32,
    url: require('@/assets/images/edit/dhBgShape/circle.svg'),
  },
  //正拱形
  ARCH: {
    id: 4,
    type: 'path',
    width: 48,
    height: 64,
    path: 'M0 24C0 10.7452 10.7452 0 24 0V0C37.2548 0 48 10.7452 48 24V64H0V24Z',
    url: require('@/assets/images/edit/dhBgShape/arch.svg'),
  },
  //倒拱形
  REVERSE_ARCH: {
    id: 5,
    type: 'path',
    width: 48,
    height: 64,
    path: 'M0 40C0 53.2548 10.7452 64 24 64V64C37.2548 64 48 53.2548 48 40V0H0V40Z',
    url: require('@/assets/images/edit/dhBgShape/reverse_arch.svg'),
  },
  //五边形
  PENTAGON: {
    id: 6,
    type: 'path',
    width: 64,
    height: 61,
    path: 'M32 0L64 23.2494L51.7771 60.8676H12.2229L0 23.2494L32 0Z',
    url: require('@/assets/images/edit/dhBgShape/pentagon.svg'),
  },
  //六边形
  HEXAGON: {
    id: 7,
    type: 'path',
    width: 56 * 0.99,
    height: 64 * 0.99,
    path: 'M27.7128 0L55.4256 16V48L27.7128 64L0 48V16L27.7128 0Z',
    url: require('@/assets/images/edit/dhBgShape/hexagon.svg'),
  },
  //正六边形
  REGULAR_HEXAGON: {
    id: 8,
    type: 'path',
    width: 64,
    height: 56,
    path: 'M64 28.0009L48 55.7137L16 55.7137L2.19146e-07 28.0009L16 0.288084L48 0.288085L64 28.0009Z',
    url: require('@/assets/images/edit/dhBgShape/regular_hexagon.svg'),
  },
  //八边形
  OCTAGON: {
    id: 9,
    type: 'path',
    width: 64.65,
    height: 64.65 ,
    path: 'M19.359 65.2217L46.1236 65.2776L65.0095 46.3126L65.0655 19.5479L46.1004 0.662071L19.3358 0.60608L0.449915 19.5711L0.39392 46.3358L19.359 65.2217Z',
    url: require('@/assets/images/edit/dhBgShape/octagon.svg'),
  },
  //多角星20
  POLYGON_20: {
    id: 10,
    type: 'path',
    width: 64,
    height: 64,
    path: 'M32 0L36.5053 3.55458L41.8885 1.56619L45.0749 6.33901L50.8091 6.11146L52.3647 11.6353L57.8885 13.1909L57.661 18.9251L62.4338 22.1115L60.4454 27.4947L64 32L60.4454 36.5053L62.4338 41.8885L57.661 45.0749L57.8885 50.8091L52.3647 52.3647L50.8091 57.8885L45.0749 57.661L41.8885 62.4338L36.5053 60.4454L32 64L27.4947 60.4454L22.1115 62.4338L18.9251 57.661L13.1909 57.8885L11.6353 52.3647L6.11146 50.8091L6.33901 45.0749L1.56619 41.8885L3.55458 36.5053L0 32L3.55458 27.4947L1.56619 22.1115L6.33901 18.9251L6.11146 13.1909L11.6353 11.6353L13.1909 6.11146L18.9251 6.33901L22.1115 1.56619L27.4947 3.55458L32 0Z',
    url: require('@/assets/images/edit/dhBgShape/polygon_20.svg'),
  },
  //多角星36
  POLYGON_36: {
    id: 11,
    type: 'path',
    width: 64,
    height: 64,
    path: 'M32 0L34.5101 3.30959L37.5567 0.486153L39.454 4.18134L42.9446 1.92984L44.1714 5.89834L48 4.28719L48.519 8.40842L52.5692 7.48658L52.3647 11.6353L56.5134 11.4308L55.5916 15.481L59.7128 16L58.1017 19.8286L62.0702 21.0554L59.8187 24.546L63.5138 26.4433L60.6904 29.4899L64 32L60.6904 34.5101L63.5138 37.5567L59.8187 39.454L62.0702 42.9446L58.1017 44.1714L59.7128 48L55.5916 48.519L56.5134 52.5692L52.3647 52.3647L52.5692 56.5134L48.519 55.5916L48 59.7128L44.1714 58.1017L42.9446 62.0702L39.454 59.8187L37.5567 63.5138L34.5101 60.6904L32 64L29.4899 60.6904L26.4433 63.5138L24.546 59.8187L21.0554 62.0702L19.8286 58.1017L16 59.7128L15.481 55.5916L11.4308 56.5134L11.6353 52.3647L7.48658 52.5692L8.40842 48.519L4.28719 48L5.89834 44.1714L1.92984 42.9446L4.18134 39.454L0.486153 37.5567L3.30959 34.5101L0 32L3.30959 29.4899L0.486153 26.4433L4.18134 24.546L1.92984 21.0554L5.89834 19.8286L4.28719 16L8.40842 15.481L7.48658 11.4308L11.6353 11.6353L11.4308 7.48658L15.481 8.40842L16 4.28719L19.8286 5.89834L21.0554 1.92984L24.546 4.18134L26.4433 0.486153L29.4899 3.30959L32 0Z',
    url: require('@/assets/images/edit/dhBgShape/polygon_36.svg'),
  },
  //四角星
  FOUR_POINTED_STAR: {
    id: 12,
    type: 'path',
    width: 64,
    height: 64,
    path: 'M32 0L40.6429 23.3571L64 32L40.6429 40.6429L32 64L23.3571 40.6429L0 32L23.3571 23.3571L32 0Z',
    url: require('@/assets/images/edit/dhBgShape/four_pointed_star.svg'),
  },
  //五角星
  FIVE_POINTED_STAR: {
    id: 13,
    type: 'path',
    width: 62 * 0.982,
    height: 58 * 0.982,
    path: 'M31 0L38.1844 22.1115H61.4338L42.6247 35.7771L49.8091 57.8885L31 44.2229L12.1909 57.8885L19.3753 35.7771L0.566191 22.1115H23.8156L31 0Z',
    url: require('@/assets/images/edit/dhBgShape/five_pointed_star.svg'),
  },
  //六角星
  SIX_POINTED_STAR: {
    id: 14,
    type: 'path',
    width: 57 * 0.972,
    height: 64 * 0.972,
    path: 'M28.3203 0L38.7203 13.9867L56.0331 16L49.1203 32L56.0331 48L38.7203 50.0133L28.3203 64L17.9203 50.0133L0.6075 48L7.52031 32L0.6075 16L17.9203 13.9867L28.3203 0Z',
    url: require('@/assets/images/edit/dhBgShape/six_pointed_star.svg'),
  },
  //三角形
  TRIANGLE: {
    id: 15,
    type: 'path',
    width: 64 * 0.9745,
    height: 54 * 0.9745,
    path: 'M32 0L63.1769 54H0.823086L32 0Z',
    url: require('@/assets/images/edit/dhBgShape/triangle.svg'),
  },
  //倒三角形
  REVERSE_TRIANGLE: {
    id: 16,
    type: 'path',
    width: 64 * 0.9745,
    height: 54 * 0.9745,
    path: 'M32 54L63.1769 0H0.823086L32 54Z',
    url: require('@/assets/images/edit/dhBgShape/reverse_triangle.svg'),
  },
  //菱形
  RHOMBUS: {
    id: 17,
    type: 'path',
    width: 64,
    height: 64,
    path: 'M32 0L64 32L32 64L0 32L32 0Z',
    url: require('@/assets/images/edit/dhBgShape/rhombus.svg'),
  },
}

// 移动图层的方向
export const MOVE_LAYER_DIRECTION = {
  UPLAYER: 1,      // 上一层
  DOWNLAYER: 2,    // 下一层
  TOPLAYER: 3,     // 移到最前一次
  LASTLAYER: 4,    // 移到最后一层
}

export const UPLOAD_TYPE = {
  DEFAULT: 1 ,  // 默认
  BACKGROUND: 2, // 底纹/背景
  MATEERIAL: 3, // 素材
  IDENTIFY: 4, // 企业标识
}

export const JSON_BASE_DATA = ['fonts', 'width', 'height', 'id', 'uuid', 'clipType', 'mediaType', 'ratio', 'resId', 'shapeId', 'cover', 'fontUrl', 'videoUrl', 'volume', 'fromSVG']